import * as React from "react"
import styled from "styled-components"
import { Spacer } from "../spacers"
import { theme } from "../../theme"
import H3 from "../typography/H3"

interface ButtonProps {
  variant: "blue" | "green" | "red" | "yellow"
  title: string
  onClick?: () => void
  icon?: React.ReactNode
  disabled?: boolean
}

const ButtonContainer = styled.button<{
  disabled?: boolean
  hovercolor: string
}>`
  cursor: ${(props) => (props.disabled ? undefined : "pointer")};
  border-radius: ${(props) => props.theme.borders.buttonRadius};
  padding: 24px 38px;
  display: flex;
  align-items: center;
  box-shadow: 0px 2px 6px 0px rgba(119, 119, 119, 0.25);
  border: none;
  background-color: ${(props) => (props.disabled ? props.theme.colors.greyDisabled : "rgba(255, 255, 255, 0.74)")};
  position: relative;

  :hover {
    background: ${(props) => (props.disabled ? undefined : props.hovercolor)};
    box-shadow: 0px 2px 6px 0px rgba(119, 119, 119, 0.25);
  }

  :active {
    box-shadow: "none";
  }
`

const ColorfulButton: React.FunctionComponent<ButtonProps> = ({ variant = "blue", title, onClick, icon, disabled }) => {
  const hoverColor =
    variant === "blue"
      ? theme.gradients.blue
      : variant === "green"
        ? theme.gradients.green
        : variant === "red"
          ? theme.gradients.red
          : theme.gradients.yellow

  return (
    <ButtonContainer onClick={disabled ? undefined : onClick} disabled={disabled} hovercolor={hoverColor}>
      {icon}
      {icon && <Spacer spacing={1} />}
      <H3>{title}</H3>
    </ButtonContainer>
  )
}

export default ColorfulButton
